import React from 'react'

import { useMyAssesmentAPI } from 'api/assessment/useAPIAssessment'
import AndroidHandler from 'utils/androidHandler'
import { useOnlineStatus } from 'utils/hooks/useOnlineStatus'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import { BottomNav } from 'components/BottomNav'
import { REFERRER_KEY } from 'utils/hooks/useRouterHistory'
import { GATrackEvent } from 'utils/googleAnalytics'
import { USER_ID_STORAGE_KEY } from 'configs/auth'

import type { NavItem } from 'components/BottomNav'

import SearchIcon from 'assets/icons/search.svg'
import DocumentTextIcon from 'assets/icons/document-text.svg'
import ClassIcon from 'assets/icons/class.svg'

const defaultNavItems: NavItem[] = [
  {
    href: '/assessment/litnum',
    icon: SearchIcon,
    text: 'Pilihan AKM Kelas',
    disabled: false,
  },
  {
    href: '/assessment/me',
    icon: DocumentTextIcon,
    text: 'AKM Kelas Saya',
    disabled: false,
  },
]

export default function MyAssessmentBottomNav() {
  const [, , , getReferrerValue] = useLocalStorage(REFERRER_KEY, null)
  const [userId] = useLocalStorage(USER_ID_STORAGE_KEY, null)
  const limit = 20
  const isOnline = useOnlineStatus()
  const [navItems, setNavItems] = React.useState<NavItem[]>(defaultNavItems)
  const { status, data } = useMyAssesmentAPI(limit)
  const androidHandler = AndroidHandler()

  const onNavigate = (href: string) => {
    if (userId && href === defaultNavItems[0].href) {
      setTimeout(() => {
        const referrer = getReferrerValue()
        GATrackEvent({
          eventName: 'click_assessment_listing',
          eventParams: {
            event_trigger:
              referrer === defaultNavItems[1].href
                ? 'SAVED_ASSESSMENTS'
                : 'HOMEPAGE',
            user_id: userId,
          },
        })
      }, 0)
    }
  }

  React.useEffect(() => {
    if (!androidHandler.enabled) {
      const newNavItems = defaultNavItems.slice(0)
      newNavItems.splice(1, 0, {
        href: '/learning-group',
        icon: ClassIcon,
        text: 'Kelas',
        disabled: false,
      })
      setNavItems(newNavItems)
    }
  }, [androidHandler?.enabled])

  React.useEffect(() => {
    if (status === 'success') {
      let totalStudentNotScored = 0
      data.pages[0].data.forEach((item) => {
        totalStudentNotScored +=
          item.totalStudentSubmitted - item.totalStudentScored
      })
      const newNavItems = defaultNavItems.slice(0)
      newNavItems[1].badge = totalStudentNotScored
      setNavItems(newNavItems)
    }
  }, [status, data])

  return (
    <BottomNav
      navItems={navItems}
      disabled={!isOnline}
      onNavigate={onNavigate}
    />
  )
}
